<template>
  <section class="game-home">
    <iframe :src="gamePath" />

    <transition name="fade" appear>
      <div class="game-home-instructions" v-show="showInstructions">
        <div class="container">
          <div class="logo" :class="game.id" />
          <div class="instruction" v-html="instructions" />

          <CJButton fat @click="readyClicked">
            Ready
          </CJButton>
        </div>
      </div>
    </transition>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'

import CJButton from '@/components/CJButton'

export default {
  name: 'GameHome',

  components: { CJButton },

  data () {
    return {
      showInstructions: true,
    }
  },

  $bus: {
    'toggle-instructions' () {
      this.showInstructions = !this.showInstructions
    },
  },

  computed: {
    ...mapGetters([ 'gameWithId' ]),

    game () {
      return this.gameWithId(this.$route.params['id'])
    },

    gamePath () {
      return `/arcade/games/${this.game.hash}/index.htm`
    },

    instructions () {
      return /android|ip(hone|ad)/i.test(window.navigator.userAgent)
        ? this.game.instructions.mobile
        : this.game.instructions.desktop
    },
  },

  methods: {
    readyClicked () {
      this.showInstructions = false
    },
  },
}
</script>

<style lang="stylus" scoped>
  section.game-home
    width: 100%
    height: 100%
    padding: 0
    background-color: white

    iframe
      width: 100%
      height: 100%
      border: none

    .game-home-instructions
      position: absolute
      top: 50%
      left: 50%
      width: 367px
      padding: 4px
      animation: highlight-anim 1s linear infinite
      transform: translate(-50%, -50%)
      background-image: linear-gradient(to right, \
                                        #d6d6d6 0%, \
                                        #9d9fa1 25%, \
                                        #d6d6d6 50%, \
                                        #9d9fa1 75%, \
                                        #d6d6d6 100%)

      .container
        display: flex
        flex-direction: column
        justify-content: center
        align-items: center
        background-color: #1b3597
        box-sizing: border-box
        height: 100%
        padding: 30px

        .logo
          margin: 40px 0 0
          flex: none

        .instruction
          font-family: 'Futura Std Condensed'
          font-size: 28px
          font-weight: 500
          width: 100%
          margin: 31px 32px 24px
          text-align: center
          flex: 1 0 auto
          line-height: 1.4

        .cj-button
          flex: none
</style>
